import { isSunrunManaged } from "@sunrun/sales-experience-shared";
import { useFeatureFlagEnabled } from "@sunrun/sales-experience-shared/react-feature-flags";
import { ProfileIframe } from "components/organisms/ProfileIFrame";
import { useUserProfile } from "providers/UserProfile";
import { SALES_EXP_ACADEMY_PAGE_FLAG } from "constants/featureFlags";

const Profile = () => {
  const { completeProfile } = useUserProfile();
  const isSrm = isSunrunManaged(completeProfile);
  const academyPageEnabled = useFeatureFlagEnabled(SALES_EXP_ACADEMY_PAGE_FLAG);
  const page = isSrm && academyPageEnabled ? "srm-profile" : "profile";

  return <ProfileIframe page={page} />;
};

export { Profile };
